import { useState } from "react";
import { useLanguage } from "../../../../stores/LanguageStore";
import { useDisclosure } from "@mantine/hooks";
import { Button, Group, Modal, Stack, Text } from "@mantine/core";
import BackButton from "../../../../components/View/BackButton";
import { IconBrandLinkedin } from "@tabler/icons-react";
import { convertLinkedinLinks } from "../../../../api/ContactAPI";
import { notifications } from "@mantine/notifications";
import { IconLinkedin } from "../../../../components/Icons/IconLinkedin";
import LinkedinAccountSelector from "../../../../components/Selectors/LinkedinAccountSelector";

const ListConvertLinkedin = ({ current, onFinish, closeMenu }) => {
  const lang = useLanguage((s) => s.language);
  const [opened, { open, close }] = useDisclosure();
  const [loading, setLoading] = useState(false);
  const [account, setAccount] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();

    setLoading(true);
    convertLinkedinLinks({
      contact_list_id: current.id,
      linkedin_account_id: account,
    })
      .then((res) => {
        notifications.show({
          message: lang.contact_lists.convert_linkedin_links.success,
          color: "tertiary.8",
        });
        close();
        onFinish?.();
      })
      .finally(() => setLoading(false));
  };

  const handleClose = () => {
    close();
    closeMenu?.();
  };

  return (
    <>
      <Button
        onClick={open}
        leftSection={<IconLinkedin size={18} />}
        color="primary"
        variant="subtle"
        justify="start"
      >
        {lang.contact_lists.convert_linkedin_links.label}
      </Button>

      {opened && (
        <Modal
          opened={opened}
          size={"md"}
          onClose={handleClose}
          title={
            <>
              {lang.contact_lists.convert_linkedin_links.dialog.title}{" "}
              <b>
                {current?.name} #{current.id}
              </b>
            </>
          }
        >
          <Stack component={"form"} onSubmit={handleSubmit} gap={"xs"}>
            <Text c={"dimmed"}>
              {lang.contact_lists.convert_linkedin_links.dialog.text}
            </Text>

            <LinkedinAccountSelector
              label={
                lang.contact_lists.convert_linkedin_links.dialog
                  .linkedin_account
              }
              required
              value={account}
              onChange={(v) => setAccount(v?.id || null)}
              size={"sm"}
              withPool={false}
            />

            <Group justify="end" mt={"md"}>
              <BackButton onClick={handleClose} />

              <Button
                leftSection={<IconBrandLinkedin size={18} />}
                loading={loading}
                color="primary"
                type="submit"
              >
                {lang.contact_lists.convert_linkedin_links.dialog.submit_button}
              </Button>
            </Group>
          </Stack>
        </Modal>
      )}
    </>
  );
};

export default ListConvertLinkedin;
